import { render } from "./Launcher.vue?vue&type=template&id=0e543253&scoped=true"
import script from "./Launcher.vue?vue&type=script&lang=js"
export * from "./Launcher.vue?vue&type=script&lang=js"

import "./Launcher.vue?vue&type=style&index=0&id=0e543253&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e543253"]])

export default __exports__